<template>
  <div>
    <input v-model.lazy="value" v-money="money" class="form-control form-control-sm" v-bind:id="id" />
  </div>
</template>

<script>
  import {VMoney} from 'v-money'
  export default {
    props: ['id', 'value'],
    data () {
      return {
        price: "0,00",
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        }
      }
    },

    directives: {money: VMoney}
  }
</script>


// WEBPACK FOOTER //
// src/components/utils/InputMoney.vue